module.exports = __webpack_public_path__ + "static/media/interface_1.01de1c1a.gif";